import { Box, Grid, GridItem } from "@chakra-ui/react";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function Layout() {
  const [navConfig, modifyNav] = useState({
    visible: true,
    noLogo: false,
    allButtons: true,
    colorModeSwitch: true,
  });
  return (
    <Grid
      px={{ base: 4, md: 8 }}
      pb={8}
      pt={2}
      templateRows="auto 1fr"
      maxW="1920px"
      margin="auto"
    >
      <Box mb={4}>
        <Navbar {...navConfig} />
      </Box>
      <GridItem overflow="scroll">
        <Outlet
          context={{
            modifyNav,
          }}
        />
      </GridItem>
    </Grid>
  );
}
